import React from 'react';
import {Collapse} from "components/style-guide/collapse";
import Input from "components/style-guide/form/input/Input";
import SearchIcon from "components/style-guide/icons/Search.icon";
import {Link} from "@reach/router";
import AppRouters from "settings/app-routers";
import {useQuestions} from "./useQuestions";
import {Loading} from "components/index";
import CloseIcon from "components/style-guide/icons/Close.icon";
import NoRecords from "components/style-guide/no-records/NoRecords";

import styles from './questions.module.scss';
import clsx from "clsx";

export const QuestionsPage = () => {
    const {onFilter, items, loading, isFilterActive, clearFilter, search} = useQuestions();

    if (loading) return (
        <div style={{ height: '100vh' }}>
            <Loading/>
        </div>
    );

    return (
        <div className={styles.container}>
            <div className={styles.filterPanel}>
                <h3>¿Qué deseas saber?</h3>
                <Input
                    value={search}
                    suffixIcon={
                        isFilterActive &&
                        <CloseIcon stroke="rgb(132, 138, 147)" fontSize="small" onClick={clearFilter}/>
                    }
                    prefixIcon={<SearchIcon fontSize="small"/>}
                    prefixTop={10}
                    suffixTop={10}
                    placeholder="Buscar ..."
                    debounce={250}
                    onTextChange={onFilter}/>
            </div>
            <div className={styles.body}>
                {
                    items?.length === 0
                        ? <div className={clsx( {[styles.noRecord]: items?.length === 0} )}><NoRecords/></div>
                        : <>
                            <h3>Preguntas Frecuentes</h3>

                            {
                                items.map((item, index) => {
                                    return (
                                        <Collapse title={item.question} key={index}>
                                            <p>{item.answer}</p>
                                        </Collapse>
                                    )
                                })
                            }
                        </>
                }
            </div>
            <div className={styles.footerPanel}>
                <h3>¿Estás listo para comprar tu reporte?</h3>
                <Link to={AppRouters.newReport} className={styles.newReportBtn}>
                    Solicitar Reporte
                </Link>
            </div>
        </div>
    );
};
